import axios from 'axios'

/**
 *
 * @param formName
 * @param formContent {[string]: String}
 * @returns {Promise<void>}
 */
export async function sendForm({formName, formContent}) {
	try {
		return await axios.post('/.netlify/functions/forms', {
			formName,
			formData: Object.keys(formContent).map(key => ({key, value: formContent[key]})),
		})
	} catch (_) {
		throw new Error('There was an error while sending the form. Please try again')
	}
}
